import inflection from 'inflection';
import { useSearchParams } from 'react-router-dom';

import filterFormatFundSearch from 'buyside/util/filterFormatFundSearch';
import filterFormatFundTags from 'buyside/util/filterFormatFundTags';
import getMetricValue from 'buyside/util/getMetricValue';

const fundCategoriesToFormat = [
  'return_timeframe',
  'return_quartile',
  'beta_metric',
  'sharpe_metric',
  'turnover_metric',
  'management_fee',
  'incentive_fee',
  'years_operating'
];

export const formatCategory = (
  category: string,
  value: string
): { formattedCategory: string; formattedValue: string } => {
  let formattedCategory = inflection.transform(category, ['humanize', 'singularize']);

  let formattedValue = inflection.humanize(value);

  switch (category) {
    case 'intro_request':
      formattedCategory = 'Show Interested Funds';
      break;
    case 'fund_tags[]':
      formattedValue = filterFormatFundTags(value);
      break;
    case 'ticker':
      formattedValue = value.toUpperCase();
      break;
  }

  if (fundCategoriesToFormat.includes(category)) {
    ({ value: formattedValue, category: formattedCategory } = filterFormatFundSearch(
      value,
      category
    ));
  } else if (value.split('_').length === 2) {
    ({ value: formattedValue, label: formattedCategory } = getMetricValue(value, category));
  }

  if (value === 'true') formattedValue = 'yes';
  if (value === 'false') formattedValue = 'no';

  formattedCategory = formattedCategory.replace('[]', '');

  if (value === 'user_updated_at') formattedValue = 'Updated At';

  return { formattedCategory, formattedValue };
};

export const createFilterCardParams = (
  paramName: string,
  paramValue: string,
  customValues?: { categoryDisplayText?: string; valueDisplayText?: string }
): FilterCard => {
  const { formattedCategory, formattedValue } = formatCategory(paramName, paramValue);
  return {
    categoryDisplayText: customValues?.categoryDisplayText || formattedCategory,
    valueDisplayText: customValues?.valueDisplayText || formattedValue,
    paramValue,
    paramName
  };
};

interface FilterCard {
  categoryDisplayText: string;
  valueDisplayText: string;
  paramValue: string;
  paramName: string;
}

export const useFilterCards = (): FilterCard[] => {
  const [searchParams] = useSearchParams();
  const selectedFilters = [...searchParams.entries()];
  const filterCards = selectedFilters.reduce(
    (selectedFilterCards: FilterCard[], [filterType, filterValue]): FilterCard[] => {
      return ['page', 'recommended', 'fpid'].includes(filterType)
        ? selectedFilterCards
        : [...selectedFilterCards, createFilterCardParams(filterType, filterValue)];
    },
    []
  );

  return filterCards;
};
